import { useViewerPlugin } from '@stereograph/teiaviewer';
import { useQuery } from '@tanstack/react-query';
import { IdentityApi } from './IdentityApi';

const useIdentityApi = () => {
  const { plugin } = useViewerPlugin('anomaly');
  const client = plugin.identityAPiClient;

  return IdentityApi(client);
};

export const useGetAllUserByInstanceToken = () => {
  const api = useIdentityApi();

  return useQuery({
    queryKey: [api.instanceToken],
    queryFn: () => api.getAllUserByInstance(api.instanceToken),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};
